export const BRAND = "Storm Damage Pros";
export const REP_NAME = "JD Dean";
export const PHONE = "470-790-7744";
export const PHONE_TEL = "4707907744";
export const EMAIL = "jd.dean@bestchoiceroofing.com";

export const COUNTIES = [
  "Douglas", "DeKalb", "Carroll", "Fayette", "Coweta",
  "Spalding", "Henry", "Clayton", "Fulton", "Troup", "Newton",
  "Jasper", "Butts", "Lamar", "Rockdale",
  // Expansion — Dec 2025
  "Pike", "Upson", "Meriwether", "Monroe",
  "Heard",
  // Added back / new — Dec 2026
  "Cobb", "Paulding", "Bartow", "Cherokee",
  "Polk", "Gwinnett", "Haralson",
];

export const GOOGLE_REVIEW_URL = "https://www.google.com/search?sca_esv=26d9fb2b0a4b5cca&rlz=1C5MACD_en&sxsrf=ANbL-n5hzNJhlho-Nyoe630Y2CgxKn_rlA:1780860918090&si=AL3DRZHrmvnFAVQPOO2Bzhf8AX9KZZ6raUI_dT7DG_z0kV2_x1LgOXhyVDZC16YAGK3nCJeFf1bkXFaUS7hDGR8G5x5-WykMbRdIHVU9y1crvEB_5YdAMTk4VWMXO6PpJCspuN_ifNvJphMA5WevfpWioV1urj3jyg%3D%3D&q=Best+Choice+Roofing+Reviews&sa=X&ved=2ahUKEwiz-Krz7_WUAxXH6ckDHYq3N7wQ0bkNegQIOBAH&biw=1680&bih=857&dpr=2";

export const SHINGLE_LINES = [
  {
    name: "GAF Timberline Natural Shadow",
    shortName: "Natural Shadow",
    tier: "Good",
    tag: "Classic Beauty",
    blurb: "Timeless dimensional wood-shake look. The smart, dependable choice for homeowners who want long-lasting curb appeal without the upgrade fee.",
    image: "/shingle-natural-shadow.png",
    accent: "from-slate-500 to-slate-700",
    colors: ["Charcoal", "Barkwood", "Pewter Gray", "Weathered Wood"],
    perks: [
      "110 MPH wind rating",
      "Algae-resistant granules",
      "Classic dimensional shadow look",
      "Available in 6 timeless colors",
    ],
    upgrade: { label: "Included", price: "$0 Upgrade", free: true, note: "Standard with approved claim" },
    warranty: { labor: "5-Year Labor", material: "Limited Lifetime Material" },
  },
  {
    name: "GAF Timberline HDZ",
    shortName: "HDZ",
    tier: "Better",
    tag: "High Definition · America's #1",
    blurb: "America's best-selling shingle. LayerLock™ technology, unlimited wind warranty, and rich color blends that transform any home.",
    image: "/shingle-hdz.png",
    accent: "from-sky-500 to-sky-700",
    colors: ["Pewter Gray", "Charcoal", "Hunter Green", "Patriot Red", "Biscayne Blue", "Copper Canyon"],
    perks: [
      "LayerLock™ adhesive — unlimited wind warranty",
      "StainGuard Plus™ 25-year algae protection",
      "Stays-Cool reflective granules",
      "20+ designer color blends",
    ],
    upgrade: { label: "Popular Upgrade", price: "+$60 / Sq.", note: "≈ $1,800 on avg. 30sq roof", popular: true },
    warranty: { labor: "10-Year Labor", material: "Limited Lifetime Material" },
  },
  {
    name: "GAF Timberline UHDZ",
    shortName: "UHDZ",
    tier: "Best",
    tag: "Ultra High Definition · Premium",
    blurb: "The thickest, deepest, most luxurious GAF shingle ever made. Class 4 impact rated — may earn you an insurance discount every year.",
    image: "/shingle-uhdz.png",
    accent: "from-red-500 to-red-700",
    colors: ["Barkwood", "Charcoal", "Shakewood", "Slate", "Weathered Wood", "Williamsburg Slate"],
    perks: [
      "Class 4 impact — qualifies for insurance discount",
      "30% thicker than standard architectural shingles",
      "Dramatic shake-style depth and shadow lines",
      "LayerLock™ unlimited wind warranty",
    ],
    upgrade: { label: "Premium Upgrade", price: "+$120 / Sq.", note: "≈ $3,600 on avg. 30sq roof" },
    warranty: { labor: "30-Year Labor", material: "Limited Lifetime Material" },
  },
];

export const TIME_WINDOWS = [
  "9AM-11AM",
  "11AM-1PM",
  "1PM-3PM",
  "3PM-5PM",
  "5PM-7PM",
];

export const TRUST_BADGES = [
  { label: "Owens Platinum Preferred Contractor" },
  { label: "GAF National Circle Member" },
  { label: "17+ Years Roofing Experience" },
  { label: "Insurance Claim Specialist" },
];
